import { connect } from "react-redux";
import { deleteTradeInRequest, patchTradeInRequest } from "src/store/actions/tradeIn";
import TradePendingFooter from "../components/TradePending/Inputs/TradePendingFooter";
import { ApplicationStore } from "../store";

function mapStateToProps({ deal, tradeIn }: ApplicationStore) {
    return {
        tradePending: tradeIn,
        uuid: deal.uuid as string,
    };
}

const mapDispatchToProps = {
    resetTradePending: deleteTradeInRequest,
    patchTradeIn: patchTradeInRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(TradePendingFooter);
